import { SalesBrandPermissionSnapshot } from '@/components/Approval/@components/SalesBrandPermission';
import { parseSalesBrandPermissionContent } from '@/utils/approval/salesBrandPermission';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 215 Sales 브랜드 권한 변경 — 저장 content 그대로(레거시 조회와 동일, 권한 재조회 없음) */
const SalesBrandPermissionSlot = ({ data }: ContentExtraProps) => {
  const content = parseSalesBrandPermissionContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SalesBrandPermissionSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SalesBrandPermissionSlot;
